import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import React from 'react';
import InvoiceLineProductDTO from '../dtos/InvoiceLineProductDTO';

interface Props {
  invoiceLine: InvoiceLineProductDTO;
}

const InvoiceLineProduct = ({invoiceLine}: Props) => {
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col">
            <div className="d-flex flex-sm-column flex-lg-row align-items-start align-items-lg-center">
              {invoiceLine.productName}
            </div>
          </div>
          <div className="col-auto pl-3 mr-sm-5">
            <PriceFormatter amount={invoiceLine.amount!} currency={invoiceLine.currency!} />
          </div>
        </div>
      </div>
      {/* <div className="col-auto pl-3">
        <RoundButton />
      </div> */}
    </div>
  )
}

export default InvoiceLineProduct;
